export default __webpack_public_path__ + "static/media/thumb_slider_new.8575ec52.png";